var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.592 2.914a13.333 13.333 0 1114.815 22.173A13.333 13.333 0 016.592 2.914zm12.354 6.14a1.333 1.333 0 00-1.893 0l-3.054 3.066-3.053-3.067a1.339 1.339 0 10-1.893 1.894L12.119 14l-3.066 3.053a1.333 1.333 0 000 1.894 1.333 1.333 0 001.893 0l3.053-3.067 3.054 3.067a1.333 1.333 0 001.893 0 1.333 1.333 0 000-1.894L15.879 14l3.067-3.053a1.333 1.333 0 000-1.894z",
    fill: "#F2335C"
  })));
}
export default SvgErrorFilled;